// extracted by mini-css-extract-plugin
export default {"matches_container":"MatchGridLayout_matches_container__B8pLk"};